import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { EventDetails } from '../modal/event';

interface UpdateEventArchiveStatusParams {
  id: string;
  isArchive: boolean;
}

const updateEventArchiveStatus = async ({
  id,
  isArchive,
}: UpdateEventArchiveStatusParams): Promise<EventDetails> => {
  const response = await baseAPI.patch<EventDetails>(`/events/${id}/archive`, {
    isArchive,
  });
  return response.data;
};

export const useUpdateEventArchiveStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEventArchiveStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEYS.EVENTS] });
    },
  });
};
